const CONTENT_TYPE_MUSIC = 'music'
const CONTENT_TYPE_MARKETING = 'marketing'
const CONTENT_TYPE_PA = 'announcement'

const PLAYBACK_TYPE_DEFAULT = 'default'
const PLAYBACK_TYPE_AFTER_SONGS = 'after_songs'
const PLAYBACK_TYPE_AFTER_MINUTES = 'after_minutes'
const PLAYBACK_TYPE_TCP_MESSAGE = 'tcp_message'

const colors = {
  [CONTENT_TYPE_MUSIC]: {
    [PLAYBACK_TYPE_DEFAULT]: '#1976D2',
    [PLAYBACK_TYPE_AFTER_SONGS]: '#C2185B'
  },
  [CONTENT_TYPE_MARKETING]: {
    [PLAYBACK_TYPE_DEFAULT]: '#5E35B1',
    [PLAYBACK_TYPE_AFTER_SONGS]: '#5E35B1',
    [PLAYBACK_TYPE_AFTER_MINUTES]: '#5E35B1'
  },
  [CONTENT_TYPE_PA]: {
    [PLAYBACK_TYPE_DEFAULT]: '#00796B',
    [PLAYBACK_TYPE_TCP_MESSAGE]: '#00796B'
  }
}

const days = [
  { day: 1, short: 'M', name: 'Monday' },
  { day: 2, short: 'T', name: 'Tuesday' },
  { day: 3, short: 'W', name: 'Wednesday' },
  { day: 4, short: 'T', name: 'Thursday' },
  { day: 5, short: 'F', name: 'Friday' },
  { day: 6, short: 'S', name: 'Saturday' },
  { day: 7, short: 'S', name: 'Sunday' }
]

const emptyModel = {
  id: null,
  playlists: [],
  individual_files: [],
  start_time_at: null,
  end_time_at: null,
  start_date_at: null,
  end_date_at: null,
  content_type: null,
  playback_type: null,
  playback_every_songs: null,
  playback_every_minutes: null,
  playback_tcp_message: null,
  playback_content_count: null
}

export default {
  CONTENT_TYPE_MUSIC,
  CONTENT_TYPE_MARKETING,
  CONTENT_TYPE_PA,
  PLAYBACK_TYPE_DEFAULT,
  PLAYBACK_TYPE_AFTER_SONGS,
  PLAYBACK_TYPE_AFTER_MINUTES,
  PLAYBACK_TYPE_TCP_MESSAGE,
  colors,
  emptyModel,
  days
}
